import { CORE_PROJECT_CONTENT_SOURCES, resolveProjectContentCollection } from '../project/project_content_registry.mjs';

const coreOwners = new Set(CORE_PROJECT_CONTENT_SOURCES.map(source => source.ownerId));
const reasons = new Map([
  ['Unsupported or incomplete floorplan; stored raster required', 'Grundriss unvollständig oder nicht unterstützt; gespeichertes Rasterbild erforderlich'],
  ['Invalid obstacle geometry', 'Ungültige Hindernisgeometrie'],
  ['Network geometry provider missing', 'Geometrie für Rohr-/Lüftungsnetz nicht verfügbar'],
  ['Degenerate obstacle', 'Hindernis ohne nutzbare Länge'],
  ['Unsupported obstacle type', 'Hindernistyp nicht unterstützt'],
  ['Invalid object placement', 'Ungültige Objektposition oder Abmessungen']
]);
const kinds = { floorplan: 'Grundriss', obstacle: 'Hindernis', object: 'Objekt', 'room-wall': 'Raumwand' };

export function describeCommonPlanFallbacks(fallbacks, project) {
  return fallbacks.map(item => {
    const objects = item.kind === 'obstacle' ? project?.obstacles : item.kind === 'object' ? project?.objectAssets : [];
    const object = objects?.find(candidate => candidate.id === item.id);
    const name = object?.name || object?.label;
    const type = object?.type;
    return `${kinds[item.kind] || item.kind}${name ? ` „${name}“` : ''} (ID: ${item.id ?? 'fehlt'}${type ? `, Typ: ${type}` : ''}): ${reasons.get(item.reason) || item.reason}`;
  });
}

export function describeUnsupportedPlanSystems(manifest, project, supportsOwner) {
  return (manifest?.sources || []).filter(source => !coreOwners.has(source.ownerId)
    && source.collections.some(collection => collection.count > 0) && !supportsOwner(source.ownerId)).flatMap(source =>
    source.collections.filter(collection => collection.count > 0).map(collection => {
      const objects = resolveProjectContentCollection(project, collection.path) || [];
      const ids = objects.slice(0, 20).map((object, index) => object?.id ?? `ohne ID (Nr. ${index + 1})`);
      return `System ${source.ownerId}: GPU-Darstellung nicht unterstützt; ${collection.count} Elemente in ${collection.path.join('.')}`
        + (ids.length ? `; IDs: ${ids.join(', ')}${objects.length > 20 ? `; ${objects.length - 20} weitere` : ''}` : '');
    }));
}

export function describeFailedPlanScenes(answers) {
  return answers.filter(answer => !['committed', 'ready'].includes(answer.status)).map(answer =>
    `System ${answer.owner}: GPU-Szene nicht verfügbar (Status: ${answer.status}${answer.code ? `, Fehlercode: ${answer.code}` : ''}). Einzelne betroffene Elemente wurden vom System nicht gemeldet.`);
}
